import { render, staticRenderFns } from "./tyyOrderSignList.vue?vue&type=template&id=244b3806&"
import script from "./tyyOrderSignList.vue?vue&type=script&lang=js&"
export * from "./tyyOrderSignList.vue?vue&type=script&lang=js&"
import style0 from "./tyyOrderSignList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports